export default {
    name: 'pagos',
    component: () => import(/* webpackChunkName: "General" */ '@/layouts/General.vue'),
    children: [
        {
            path: '',
            name: 'home-pagos',
            component: () => import('@/modules/pagos/view/Home.vue'),
        },
        {
            path: 'add',
            name: 'add-pagos',
            component: () => import('@/modules/pagos/view/Add.vue'),
            props: (route) => {
                return {
                    id: 'new'
                }
            }
        },
        {
            path: ':id',
            name: 'edit-pagos',
            component: () => import('@/modules/pagos/view/Add.vue'),
            props: (route) => {
                return {
                    id: route.params.id
                }
            }
        }
    ]
}